module.exports = __webpack_public_path__ + "static/media/radio_background_circle.5b91f823.mp4";